import React, { useState, useEffect } from 'react';
import swal from 'sweetalert';
import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import axios from 'axios';
import Select from 'react-select'
import $ from 'jquery';
const Viewcompany = (props) => {

    const [items, setitems] = useState([]);
    const url = process.env.REACT_APP_APIURL + "Company/GetCompanies";
    useEffect(() => {
        setTimeout(() => {
            $('#example3').DataTable().destroy()
            populatedata()
        },100)
        
    }, []);
    useEffect(() => {
        $('#example3').DataTable();
    }, [items]);
    async function populatedata() {
        await fetch(url).then(res => res.json()).then(result => {
            setitems(result)
        }
        );
    }
     async function deletedata(id) {
         const urldelete = process.env.REACT_APP_APIURL + 'Company/SuperCompany?companyid='+id;
         let res = await axios.post(urldelete);
         if (res.status == 200) {
             debugger;
             swal({
                 title: "Updated Successfully",
                 icon: "success"
             })
             populatedata();

         }
    }

    async function deletedatanew(id) {
        const urldelete = process.env.REACT_APP_APIURL + 'Company/SuperCompanydelete?companyid=' + id;
        let res = await axios.post(urldelete);
        if (res.status == 200) {
            swal({
                title: "Delete Successfully",
                icon: "success"
            })
            populatedata();

        }
    }

    async function handleEdit(id) {
        const url = process.env.REACT_APP_APIURL + "Company/GetCompany?companyid=" + id
        await fetch(url).then(res => res.json()).then(result => {
           
            setupdateitems({ ...updateitems, company_id: result.company_id, name: result.name, status: result.status })
            if (result.status == "1") {
                setstatusvalue({ value: 1, label: "Active" })
            }
            else {
                setstatusvalue({ value: 2, label: "Inactive" })
            }
        });
        $("#myModal").modal('show');
    }
    function handleDeletenew(id) {
        swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this Company!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                deletedatanew(id);

            } else {
                swal("Thank You");
            }
        });
    }
    function handleDelete(id) {
        swal({
            title: "Are you sure?",
            text: "You want to active/inactive this company?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete)
            {
                deletedata(id);
              
            } else {
                swal("Thank You");
            }
        });
    }
    //////////////////////////////////////////////////
   ///////////////update unit//////////////////////// 
    //////////////////////////////////////////////////  
    const [updateitems, setupdateitems] = useState({ company_id: "", name: "", status: "" })

   
    const [status, setstatus] = useState([
        { value: 1, label: "Active" },
        { value: 2, label: "Inactive" },
    ])
    const [statusvalue, setstatusvalue] = useState();
    const handleInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setupdateitems({ ...updateitems, [name]: value })
    }
    const refresh = () => {
        setupdateitems({ ...updateitems, company_id: "", name: "", status: "" });
        setstatusvalue(null)
    }
    const savemethod = async (data) => {
        const url = process.env.REACT_APP_APIURL + "Company/UpdateCompany";
        await fetch(url, {
            method: "POST",
            headers: {
                'Accept': "json",
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then(res => {
            if (res.status == 200) {
                swal({
                    title: "Saved Successfully",
                    //  text: "Once deleted, you will not be able to recover this imaginary file!",
                    icon: "success"
                })
                $("#myModal").modal('hide')
                populatedata();
                
                refresh();

            }
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        savemethod(updateitems);
    }
    return (
        <div className="row">
            <div className="col-12">
                <div className="card">
                    <div className="card-header">
                        <h3 className="me-auto mb-0">View Companies List</h3>
                    </div>
                    <div className="card-body">

                        <div className="table-responsive">
                            <table id="example3" className="display" data-page-length='50'>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                        <th>Active/Deactive</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {items.map(item =>
                                        item.status == "1" ? (
                                            <tr key={item.company_id}>
                                                <td>{item.name}</td>
                                                <td>{item.status == "1" ? "Active" : "Inactive"}</td>
                                                <td>
                                                    <span className="d-flex">
                                                        
                                                        <button href="#" className="btn btn-danger shadow btn-xs sharp"
                                                            onClick={(id) => handleDeletenew(item.company_id)}>
                                                            <i className="fa fa-trash"></i>
                                                        </button>
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="d-flex">
                                                        {/*<button href="#" className="btn btn-primary shadow btn-xs sharp me-2"*/}
                                                        {/*    onClick={(id) => handleEdit(item.company_id)}>*/}
                                                        {/*    <i className="fas fa-pencil-alt"></i>*/}
                                                        {/*</button>*/}
                                                        <button href="#" className="btn btn-light shadow sharp me-2"
                                                            onClick={() => handleDelete(item.company_id)}>
                                                            Active
                                                        </button>
                                                        {/*<button href="#" className="btn btn-danger shadow btn-xs sharp"*/}
                                                        {/*    onClick={(id) => handleDelete(item.unitId)}>*/}
                                                        {/*    <i className="fa fa-trash"></i>*/}
                                                        {/*</button>*/}
                                                    </span>
                                                </td>
                                            </tr>
                                        ) :
                                            <tr key={item.company_id}>
                                                <td>{item.name}</td>
                                                <td>{item.status == "1" ? "Active" : "Inactive"}</td>
                                                <td>
                                                    <span className="d-flex">

                                                        <button href="#" className="btn btn-danger shadow btn-xs sharp"
                                                            onClick={(id) => handleDeletenew(item.company_id)}>
                                                            <i className="fa fa-trash"></i>
                                                        </button>
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="d-flex">
                                                        {/*<button href="#" className="btn btn-primary shadow btn-xs sharp me-2"*/}
                                                        {/*    onClick={(id) => handleEdit(item.company_id)}>*/}
                                                        {/*    <i className="fas fa-pencil-alt"></i>*/}
                                                        {/*</button>*/}
                                                        <button href="#" className="btn btn-dark shadow sharp me-2"
                                                            onClick={() => handleDelete(item.company_id)}>
                                                            Unactive
                                                        </button>
                                                        {/*<button href="#" className="btn btn-danger shadow btn-xs sharp"*/}
                                                        {/*    onClick={(id) => handleDelete(item.unitId)}>*/}
                                                        {/*    <i className="fa fa-trash"></i>*/}
                                                        {/*</button>*/}
                                                    </span>
                                                </td>
                                            </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div id="myModal" className="modal fade " tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="card">
                            <div className="card-header">
                                <h3 className="me-auto mb-0">Add Company</h3>
                            </div>
                            <div className="card-body">

                                <div className="basic-form">
                                    <form action="" onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="mb-3 col-sm-6">
                                                <label className="form-label">Name</label>
                                                <input type="text" autoComplete="off" className="form-control" name="name" value={updateitems.name} onChange={handleInput} required />
                                            </div>
                                            <div className="mb-3 col-sm-6">
                                                <label className="form-label">Status</label>
                                                <Select options={status} value={statusvalue} onChange={(e) => { setstatusvalue(e); setupdateitems({ ...updateitems, status: e.value }) }} />
                                            </div>
                                        </div>
                                        <button type="submit" className="btn btn-primary">Save</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Viewcompany;